module.exports = __webpack_public_path__ + "img/file-empty@2x.64b62f0f.png";